import { render, staticRenderFns } from "./commission-systems-editor.pug?vue&type=template&id=4f7665d1&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./commission-systems-editor.scss?vue&type=style&index=0&id=4f7665d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7665d1",
  null
  
)

export default component.exports